// utils/passwordValidation.js
// Delad validering för lösenord

/**
 * Validerar lösenord enligt säkerhetskrav
 * @param {string} password - Lösenordet att validera
 * @returns {Array<string>} Array med felmeddelanden, tom array om lösenordet är giltigt
 */
export const validatePassword = (password) => {
  const errors = [];
  
  if (!password || password.length < 8) {
    errors.push('Minst 8 tecken');
  }
  if (password && !/[A-Z]/.test(password)) {
    errors.push('Minst en stor bokstav');
  }
  if (password && !/[a-z]/.test(password)) {
    errors.push('Minst en liten bokstav');
  }
  if (password && !/[0-9]/.test(password)) {
    errors.push('Minst en siffra');
  }
  if (password && !/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push('Minst ett specialtecken (!@#$%^&*(),.?":{}|<>)');
  }
  
  return errors;
};

/**
 * Beräknar lösenordsstyrka
 * @param {string} password - Lösenordet
 * @returns {string} 'weak', 'good', 'medium', eller 'strong'
 */
export const getPasswordStrength = (password) => {
  if (!password || password.length === 0) {
    return '';
  }
  
  const errors = validatePassword(password);
  if (errors.length > 0) {
    return 'weak';
  }
  
  if (password.length >= 12) {
    return 'strong';
  } else if (password.length >= 10) {
    return 'medium';
  } else {
    return 'good';
  }
};

